import MembersTable from "../../components/functional-components/Tables/MembersTable"
import {useContext, useEffect, useState} from "react"
import AuthContext from "../../store/auth-context"
import UserContext from "../../store/user-context"
import axios from "axios"
import Loading from "../../components/ui-components/Loading/Loading"
import PageTitle from "../../components/ui-components/PageTitle/PageTitle"
import Modal from "../../components/ui-components/Modal/Modal"
import useModal from "../../hooks/useModal"
import MemberProfile from "../../components/functional-components/MemberProfile/MemberProfile";
import SorryTheresAProblem from "../../components/ui-components/SorryTheresAProblem/SorryTheresAProblem";
import DeleteMember from "../../components/functional-components/DeleteMember/DeleteMember";

function Members(){

    const authCtx = useContext(AuthContext)
    const userCtx = useContext(UserContext)
    const {showModal: showProfileModal, toggleModal: toggleProfileModal} = useModal()
    const {showModal: showDeleteModal, toggleModal: toggleDeleteModal} = useModal()

    const [loading, setLoading] = useState(true)
    const [members, setMembers] = useState(false)
    const [memberId, setMemberId] = useState(false)
    const [memberToDelete, setMemberToDelete] = useState(false)

    const showMemberHandler = (id) =>{
        setMemberId(id)
        toggleProfileModal()
    }

    function deleteConfirmHandler(id){
        const member = members.filter(member => (member.id === id))[0]
        setMemberToDelete(member)
        toggleDeleteModal()
    }

    function updateMembers(id){
        const updatedMembers = members.filter(member => (member.id !== id))
        setMembers(updatedMembers)
    }

    function updateMemberInList(updatedMember){
        const updatedMembers = members.map(member =>
            member.id === updatedMember.id ? {...member, ...updatedMember} : member
        )
        setMembers(updatedMembers)
    }

    useEffect(()=>{

        setTimeout(function(){

            if(authCtx.id){
                const config = {
                    headers: {
                        "Content-type": "application/json",
                        "Authorization": "Bearer " + authCtx.token,
                    },
                }

                axios.get('/api/users/', config).then(response => {
                    if(response.status === 200){
                        setLoading(false)
                        if(response.data !== 'error'){
                            setMembers(response.data)
                        }
                    }else{
                        setLoading(false)
                        setMembers(false)
                    }
                }).catch(function (error) {
                    if (error) {
                        setLoading(false)
                        setMembers(false)
                    }
                })
            }
        }, 500)
    }, [authCtx.id, authCtx.token, userCtx])



    return(
        <>
            <PageTitle>Members</PageTitle>
            {loading ? <Loading/> : !members ? <SorryTheresAProblem message={"No members found."} /> :
                <MembersTable
                    viewProfile={(id) => showMemberHandler(id)}
                    data={members}
                    withDelete={authCtx.userType === 'super-admin'}
                    deleteConfirm={authCtx.userType === 'super-admin' ? (id) => deleteConfirmHandler(id) : () => {}}
                />
            }

            <Modal
                showModal={showProfileModal}
                toggleModal={toggleProfileModal}
            >
                <MemberProfile
                    memberId={memberId}
                    onMemberUpdate={updateMemberInList}
                />
            </Modal>

            <Modal
                showModal={showDeleteModal}
                toggleModal={toggleDeleteModal}
            >
                <DeleteMember
                    user={memberToDelete}
                    updateMembers={showDeleteModal ? (id) => (updateMembers(id)) : () => {}}
                    closeModal={showDeleteModal ? () => toggleDeleteModal() : () => {}}
                />
            </Modal>
        </>
    )
}

export default Members